<template>
  <div class="container" style="overflow: visible">
    <ul id="menu" class="menu">
      <li
        data-menuanchor="page1"
        style="margin: -5px"
        v-bind:class="{ active: activePage === 1 }"
      >
        <a href="#page1">About</a>
      </li>
      <li
        data-menuanchor="page2"
        style="margin: -5px"
        v-bind:class="{ active: activePage === 2 }"
      >
        <a href="#page2">Web Dev</a>
      </li>
      <li
        data-menuanchor="page3"
        style="margin: -5px"
        v-bind:class="{ active: activePage === 3 }"
      >
        <a href="#page3">Aviation</a>
      </li>
      <li v-if="false">
        <a
          href="https://twitter.com/"
          target="_blank"
          rel="noopener"
          class="twitter-share"
        >
          <i>
            <svg viewBox="0 0 512 512">
              <path
                d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"
              ></path>
            </svg>
          </i>
        </a>
      </li>
    </ul>

    <full-page ref="fullpage" :options="options" id="fullpage">
      <div class="section">
        <div class="aboutme-div" id="aboutme">
          <div class="img-container">
            <img src="/img/me_w1024.jpg" class="me-img2" />
            <p class="about-text">
              Living in Istanbul.<br />
              Working as
              <u style="cursor: pointer" @click="gotoLinkedin()"
                >Software Engineer.</u
              ><br />
              <u style="cursor: pointer" @click="gotoMediumHowIBecomePilot()"
                >Enjoy flying</u
              >
              Single Engine Planes.<br />
              <u style="cursor: pointer" @click="gotoMedium()"
                >Writing at Medium</u
              >
              now and then.<br />
            </p>
          </div>
        </div>
      </div>
      <div class="section white-base">
        <div class="center-container flex-container">
          <!--
          <div class="medium-wrapper">
            Vue Weather App Part-2: Konum Servisleri
            <div>
              <img
                src="https://cdn-images-1.medium.com/max/1024/1*uGbwF5rgu2q3oo8CH_XQjg.jpeg"
                width="250px"
                style="display: inline; float: left"
              />
            </div>
            <div class="medium-title"></div>
          </div>-->
          <div
            v-for="article in mediumSWDItems"
            v-bind:key="article.id"
            style="margin-bottom: 10px"
            class="flex-item"
          >
            <medium-cards
              :title="article.title"
              :subtitle="article.subtitle"
              :linkUrl="article.linkUrl"
              :imgSrc="article.imgSrc"
            ></medium-cards>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="center-container"></div>
      </div>
    </full-page>
    <floating-socials></floating-socials>
  </div>
</template>

<script>
import FloatingSocials from "./FloatingSocials.vue";
import MediumCards from "./MediumCards.vue";
export default {
  components: { FloatingSocials, MediumCards },
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data: function () {
    return {
      activePage: 1,
      options: {
        afterLoad: this.afterLoad,
        navigation: true,
        anchors: ["page1", "page2", "page3"],
        sectionsColor: [
          "#c9c9c9",
          "lightblue",
          "#0798ec",
          "#fec401",
          "#1bcee6",
          "#ee1a59",
          "#2c3e4f",
          "#ba5be9",
          "#b4b8ab",
        ],
      },
      mediumSWDItems: [
        {
          id: 1,
          title: "Vue Weather App Part-1: Axios ile API erişimi",
          subtitle:
            "This is series of articles to cover Single Page Application fundamentals",
          imgSrc:
            "https://cdn-images-1.medium.com/max/345/1*iKxjSUB_uHtQV2nkhJOfKw.png",
          linkUrl:
            "https://ercanosmanoglu.medium.com/vue-weather-app-part-1-axios-ile-api-eri%C5%9Fimi-8b1dcc494940?source=rss-6091265720f6------2",
        },
        {
          id: 2,
          title: "Vue Weather App Part-2: Konum Servisleri",
          subtitle:
            "This second story in the series that is on location services and how to use it.",
          imgSrc:
            "https://cdn-images-1.medium.com/max/1024/1*uGbwF5rgu2q3oo8CH_XQjg.jpeg",
          linkUrl:
            "https://ercanosmanoglu.medium.com/vue-weather-app-part-1-axios-ile-api-eri%C5%9Fimi-8b1dcc494940?source=rss-6091265720f6------2",
        },
        {
          id: 3,
          title: "Vue Weather App Part-2: Konum Servisleri",
          subtitle:
            "This second story in the series that is on location services and how to use it.",
          imgSrc:
            "https://cdn-images-1.medium.com/max/1024/1*uGbwF5rgu2q3oo8CH_XQjg.jpeg",
          linkUrl:
            "https://ercanosmanoglu.medium.com/vue-weather-app-part-1-axios-ile-api-eri%C5%9Fimi-8b1dcc494940?source=rss-6091265720f6------2",
        },
      ],
    };
  },
  methods: {
    gotoLinkedin() {
      const refUrl = "https://tr.linkedin.com/in/ercanosmanoglu";
      window.open(refUrl, "_blank");
    },
    gotoMedium() {
      const refUrl = "https://medium.com/@ercanosmanoglu";
      window.open(refUrl, "_blank");
    },
    gotoMediumHowIBecomePilot() {
      const refUrl =
        "https://medium.com/@ercanosmanoglu/nas%C4%B1l-pilot-oldum-49f4da5ed59d";
      window.open(refUrl, "_blank");
    },

    afterLoad: function (origin, destination, direction) {
      console.log(origin, destination, direction);
      console.log("destination", destination.anchor);
      if (destination.anchor === "page1") {
        this.activePage = 1;
      } else if (destination.anchor === "page2") {
        this.activePage = 2;
      } else {
        this.activePage = 3;
      }

      console.log("After load....");
      console.log(destination);
    },
  },
  mounted() {
    this.$refs.fullpage.api.setAllowScrolling(false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  background: #c9c9c9;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
table {
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-weight: normal;
  font-style: normal;
}
strong {
  font-weight: bold;
}
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
  margin: 0;
  padding: 0;
}
q:before,
q:after {
  content: "";
}
abbr,
acronym {
  border: 0;
}
* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}

/* Custom
 * --------------------------------------- */
body {
  font-family: arial, helvetica;
}
.section {
  position: relative;
}
#section-1 h2 {
  color: #fff;
  font-size: 10em;
  font-weight: 900;
}
#section-1 h1 {
  font-size: 2em;
  font-weight: 100;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  margin: 1.5em auto 1em auto;
  color: #35495e;
  padding-right: 30px;
  padding-left: 30px;
}
#section-1 li {
  display: inline-block;
  margin: 1.25em 0.3em;
}
.section-1-button {
  padding: 0.93em 1.87em;
  background: #35495e;
  border-radius: 5px;
  display: block;
  color: #fff;
}
h3 {
  font-size: 5em;
  text-align: center;
  color: #fff;
  font-weight: bold;
}
#logo {
  position: fixed;
  top: 20px;
  left: 20px;
  color: #fff;
  font-weight: bold;
  z-index: 99;
  font-size: 1.9em;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
}

/* Menu
 * --------------------------------------- */
#menu-line {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 159px;
  height: 2px;
  background: #fff;
}

#menu {
  position: fixed;
  z-index: 2;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  letter-spacing: 1px;
  font-size: 1.1em;
  top: 10px;
  right: 40px;
  height: 20px;
}

#menu li {
  display: inline-block;
  margin: 0px -5px;
  position: relative;
}
#menu a {
  color: #fff;
  padding: 0 0.9em 0.9em 0.9em;
}
#menu li.active a:after {
  content: "";
  margin: 0 1.1em 0 1.1em;
  height: 2px;
  background: #fff;
  display: block;
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  display: block;
}

/* Actions buttons
 * --------------------------------------- */
.actions {
  position: fixed;
  bottom: 2%;
  margin: 0 auto;
  z-index: 99;
  left: 0;
  right: 0;
}
.actions li {
  display: inline-block;
  margin: 0.3em 0.3em;
}
.actions-button {
  padding: 0.73em 1.47em;
  background: rgba(53, 73, 94, 0.47);
  border-radius: 5px;
  display: block;
  color: #fff;
  cursor: pointer;
}

/* Twitter
 * --------------------------------------- */
.twitter-share i {
  vertical-align: middle;
  position: relative;
  top: 2px;
  display: inline-block;
  width: 38px;
  height: 14px;
  color: white;
  top: -4px;
  left: -2px;
  fill: #fff;
}
.twitter-share svg {
  height: 40px;
  margin-top: -10px;
}
.view-github {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 999;
  padding: 0.93em 1.87em;
  background: #35495e;
  border-radius: 5px;
  display: block;
  color: #fff;
}
.me-img {
  border-radius: 50%;
  z-index: 1;
  width: 50%;
  max-width: 350px;
  margin: 50px 0%;
}
.aboutme-div {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.img-container {
  display: inline-block;
  margin-top: 30px;
}

.me-img2 {
  margin: auto;
  width: min(100%, 500px);
  border-radius: 5%;
  display: block;
}
@media only screen and (max-width: 820px) {
}
.about-text {
  background: rgb(0, 0, 0); /* Fallback color */
  background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */
  color: #f1f1f1; /* Grey text */
  width: min(90%, 360px); /* Full width */
  margin: -150px auto;
  padding: 20px; /* Some padding */
  border-radius: 10px;
  z-index: 99;
  position: relative;
}

.center-container {
  position: relative;
  top: 25px;
  margin: auto;
  padding: 20px;
  width: 750px;
  max-width: 90%;
  height: 85vh;
  overflow: scroll;
  z-index: 1;
}

.debug {
  border: 2px solid #cd1821;
}

.medium-wrapper {
  padding: 10px;
  width: 450px;
  max-width: 90%;
}

.white-base {
  color: white;
}

.flex-container {
  display: flex;
  flex-direction: row;
}

.flex-container > div {
  margin: 5px;
  padding: 5px;
}

.flex-item {
  padding: 10px;
  flex: 50%;
}

@media only screen and (max-width: 820px) {
  #menu {
    bottom: 20px;
  }
  .flex-container {
    flex-direction: column;
  }
}
@media only screen and (min-width: 821px) {
  #menu {
    top: 10px;
    right: 40px;
  }
  .flex-container {
    flex-direction: row;
  }
}
</style>
